module.exports = __webpack_public_path__ + "img/placeholder.d8a74c2e.png";